import React from 'react'
import PropTypes from 'prop-types'
import { MyButton } from '@interstellar-component'

/**
 * A read that failed, in place of what it would have shown (a table, a page):
 * what failed, the backend's message, and a retry. `children` = extra actions.
 */
export default function LoadError({ title, message, onRetry, children }) {
  return (
    <div role="alert" className="flex flex-1 flex-col items-center justify-center gap-4 px-8 py-12 text-center">
      <div className="flex flex-col gap-1">
        <p className="text-lg font-semibold text-gray-900">{title}</p>
        {message && <p className="max-w-md text-sm text-gray-500">{message}</p>}
      </div>
      <div className="flex gap-3">
        {children}
        {onRetry && (
          <MyButton type="button" color="primary" variant="filled" size="md" onClick={onRetry}>
            Try again
          </MyButton>
        )}
      </div>
    </div>
  )
}

LoadError.propTypes = {
  title: PropTypes.node.isRequired,
  message: PropTypes.node,
  onRetry: PropTypes.func,
  children: PropTypes.node,
}
